import {ADD_DEPOT, SET_DEPOTS, UPDATE_DEPOT} from '../actionTypes';
import {IDepot} from 'constants/interfaces';

export type DepotState = {lastUpdate: number; depots: IDepot[]};
const initialState: DepotState = {lastUpdate: 0, depots: []};

export default function (
  state = initialState,
  action: {type: string; payload: any},
) {
  switch (action.type) {
    case SET_DEPOTS: {
      const depots: IDepot[] = action.payload || [];
      const stateUpdate: DepotState = {
        lastUpdate: new Date().getTime(),
        depots: depots.map((depot) => ({...depot})),
      };
      return stateUpdate;
    }

    case UPDATE_DEPOT: {
      const depotUpdate: IDepot = action.payload;
      if (!depotUpdate) return state;

      const stateUpdate: DepotState = {
        lastUpdate: state.lastUpdate,
        depots: state.depots.map((depot) => {
          if (depot.id === depotUpdate.id) return {...depotUpdate};
          return depot;
        }),
      };
      return stateUpdate;
    }

    case ADD_DEPOT: {
      const depot: IDepot = action.payload;
      if (!depot) return state;
      const stateUpdate: DepotState = {
        lastUpdate: state.lastUpdate,
        depots: [depot, ...state.depots],
      };
      return stateUpdate;
    }

    default:
      return state;
  }
}
